import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.parse-int.js";
import { teaser_attribute, slugify } from "../utils/_utils";
jQuery(function ($) {
  /**
   * Automatically select the chosen variation on the corresponding product teaser
   */
  jQuery(document).on('change', '.xts-fbt-product-variation', function () {
    var variation_value = $(this).find(':selected').html().trim().split(',')[0];
    var product_id = $(this).closest('.xts-fbt-product').attr('data-id');

    //Minus numbers are outputted as plus in variation data value field, hence we transform values to plus too 
    if (!isNaN(variation_value)) {
      variation_value = Math.abs(parseInt(variation_value));
    } else {
      variation_value = slugify(variation_value);
    }
    $('.xts-product.product[data-id="' + product_id + '"] .xts-loop-swatch[data-attr="pa_' + teaser_attribute + '"][data-value="' + variation_value + '"]').trigger('click');
  });
});